import { useCallback, useEffect, useRef, useState } from 'react';

import {
  MOUSE_DOWN_EVENT,
  MOUSE_MOVE_EVENT,
  MOUSE_UP_EVENT
} from './constants';

export const useTouchSideScroll = (containerRef) => {
  const [containerRefIsSet, setContainerRefIsSet] = useState(false);
  const [containerElement, setContainerElement] = useState();
  const isScrolling = useRef();

  useEffect(() => {
    const moveHandler = (event) => {
      if (containerRef.current) {
        containerRef.current.scrollLeft =
          window.startScroll + window.startCoordinates - event.pageX;
      }
      if (isScrolling.current === false) {
        document.removeEventListener(MOUSE_MOVE_EVENT, moveHandler);
      }
    };
    const mouseDownHandler = (event) => {
      window.startCoordinates = event.pageX;
      window.startScroll = containerRef.current.scrollLeft;
      isScrolling.current = true;
      document.addEventListener(MOUSE_MOVE_EVENT, moveHandler);
    };
    const mouseUpHandler = () => {
      document.removeEventListener(MOUSE_MOVE_EVENT, moveHandler);
    };

    if (containerRef && containerRef.current && !containerRefIsSet) {
      setContainerRefIsSet(true);
      setContainerElement(containerRef.current);

      containerRef.current.addEventListener(MOUSE_DOWN_EVENT, mouseDownHandler);
      containerRef.current.addEventListener(MOUSE_UP_EVENT, mouseUpHandler);
    }
    return () => {
      if (containerElement) {
        containerElement.removeEventListener(
          MOUSE_DOWN_EVENT,
          mouseDownHandler
        );
        containerElement.removeEventListener(MOUSE_UP_EVENT, mouseUpHandler);
      }
    };
  }, [containerRef, containerElement, containerRefIsSet]);

  const stopTouchScroll = useCallback(() => {
    isScrolling.current = false;
  }, []);

  return stopTouchScroll;
};
